document.addEventListener("DOMContentLoaded", function() {

    // Get the button
    let footerBtn = document.getElementById("footer-svg-wrapper");

    // When the user clicks on the button, scroll to the top of the document
    footerBtn.addEventListener('click', function() {
        jumpToTop();
    });

    function jumpToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // smooth scroll
        });
    }
});
